module.exports = __webpack_public_path__ + "img/SaaS活动页面调整.bb200a48.jpg";